import { render, staticRenderFns } from "./ClientDataForm.vue?vue&type=template&id=6f8c7f28&scoped=true&"
import script from "./ClientDataForm.vue?vue&type=script&lang=js&"
export * from "./ClientDataForm.vue?vue&type=script&lang=js&"
import style0 from "./ClientDataForm.vue?vue&type=style&index=0&id=6f8c7f28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8c7f28",
  null
  
)

export default component.exports